export default __webpack_public_path__ + "static/media/spookywebdoor.3743f22e.png";